import React, { useState, useEffect, useRef } from "react";
import { Container, Grid, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

import { styled } from "@mui/material/styles";
import { Element, Link } from "react-scroll";
import { useMyContext } from "../../MyContext";
import Seo from "../Seo";
import {
  getUniqueCategories,
  getSubcategories,
  filterMenuItemsId,
  getLangMenu,
  menuUpd,
  categories,
} from "../../assets/1menu1";
import { useTranslation } from "react-i18next";
import FilterList from "./FilterList";
import SubFilter from "./SubFilter";
import ModalComponent from "../Modal";
import ClickableMenuItem from "./ClickableMenuItem";
import { handleSendTech } from "../../assets/actionsTech";
import IntroModal from "../IntroModal"

const SectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.dark,
  fontFamily: theme.typography.h1.fontFamily,
  fontWeight: 700,
  textTransform: "uppercase",
  fontSize: 40,
  marginBottom: theme.spacing(0.5),
  marginTop: theme.spacing(0.5),
}));

const Section = styled("section")(({ theme }) => ({
  backgroundColor: theme.palette.secondary.beige,
  padding: theme.spacing(1, 0),
  textAlign: "center",
}));

const FilterListContainer = styled("div")(() => ({
  overflowY: "auto",
  maxHeight: "100vh",
  position: "sticky",
  zIndex: 1000,
  top: 0,
}));

 function Menu({ menuRef, headerRef }) {
  const gridRef = useRef(null);
  const {
    lang,
    showInitialHeader,
    loadingModal,
    modalContent,
    hideModal,
    modalVisible,
    run,
    onlyMenuFromParams,
  } = useMyContext();
  const { t } = useTranslation();
  const location = useLocation();

  const itemVariants = {
    hidden: { opacity: 0, scale: 0 },
    visible: (index) => ({
      opacity: 1,
      scale: 1,
      transition: {
        delay: index * 0.1,
        duration: 0.5,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    }),
  };

  const [activeFilter, setActiveFilter] = useState("*");
  const [activeFilterId, setActiveFilterId] = useState("*");
  const [activeSubFilter, setActiveSubFilter] = useState(null);
  const [activeSubFilterId, setActiveSubFilterId] = useState(null);
  const [subCategories, setSubCategories] = useState(null);
  const [subCategoriesId, setSubCategoriesId] = useState(null);
  const [filteredMenuItems, setFilteredMenuItems] = useState([]);
  

  useEffect(() => {
    if (activeFilter === "*" && !onlyMenuFromParams) {
      setFilteredMenuItems(getLangMenu(menuUpd, lang));
    } else {
      const filteredItemsId = filterMenuItemsId(
        menuUpd,
        activeFilterId,
        lang,
        null,
        onlyMenuFromParams
      );
      setFilteredMenuItems( filteredItemsId );


      const subcategoriesResult = getSubcategories(
        menuUpd,
        categories,
        activeFilterId,
        lang
      );

      const subCategories = subcategoriesResult?.name;
      const subCategoriesIds = subcategoriesResult?.ids;

      setSubCategoriesId(subCategoriesIds);
      setSubCategories(subCategories);
    }
  }, [activeFilter, lang, activeFilterId, onlyMenuFromParams, activeSubFilter]);

  const [filteredCats, setFilteredCats] = useState(null);

  useEffect(() => {
    const uniqueCategories = getUniqueCategories(
      menuUpd,
      lang,
      categories,
      onlyMenuFromParams,
      filteredMenuItems
    );
    setFilteredCats(uniqueCategories);
    // eslint-disable-next-line
  }, [lang]);

  useEffect(() => {
    setSubCatLen(subCategories?.length || 0);
  }, [subCategories]);

  const [subCatLen, setSubCatLen] = useState(subCategories?.length || 0);

  const menuTitle = () => {
    if (onlyMenuFromParams == 2) {
      return "Beach Menu";
    }
    return t("menu.Menu");
  };

  
  useEffect(() => {
    // eslint-disable-next-line
    if (onlyMenuFromParams == 1) {
      handleSendTech(1);
    }
    // eslint-disable-next-line
    if (onlyMenuFromParams == 2) {
      handleSendTech(2);
    }
  },[onlyMenuFromParams]);


   
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [isIntroModalOpen, setIsIntroModalOpen] = useState(false);

   useEffect( () =>
   {
    if (isFirstRender && onlyMenuFromParams==2) {
      setIsIntroModalOpen(true);
      setIsFirstRender(false); // Ensures modal is shown only on the first render
    }
  }, [isFirstRender,onlyMenuFromParams]);

  const handleCloseIntroModal = () => {
    setIsIntroModalOpen(false);
  };
  return (
    <>
      <Seo
        title={menuTitle()}
        description={t("about.about")}
        pathname={location.pathname}
        lang={lang}
      />
      <Section id="menu" ref={menuRef}>
        {modalVisible && (
          <ModalComponent
            loading={loadingModal}
            content={modalContent}
            onClose={hideModal}
            run={run}
          />
        ) }
           <IntroModal onClose={handleCloseIntroModal} open={isIntroModalOpen} lang={lang} />
        {/* {onlyMenuFromParams == 2 && (
          <DefaultButton
            label="This is Beach Menu. See Full Menu"
            onClick={() => {
              setOnlyMenu(1);
            }}
            relative={true}
          />
        )}
        {onlyMenuFromParams == 1 && (
          <DefaultButton
            label="See Beach Menu"
            onClick={() => {
              setOnlyMenu(2);
            }}
            relative={true}
          />
        )}{" "} */}
        <Link to="menu-items" offset={-290} smooth>
          <SectionTitle variant="h3">{menuTitle()}</SectionTitle>
        </Link>
        <Element name="menu-list">
          <FilterListContainer>
            <FilterList
              uniqueCategories={filteredCats}
              setActiveFilter={setActiveFilter}
              setActiveFilterId={setActiveFilterId}
              gridRef={gridRef}
              showCallWaiterButton={showInitialHeader}
              activeFilterId={activeFilterId}
              onlyMenuFromParams={onlyMenuFromParams}
            />
            <SubFilter
              menu={menuUpd}
              activeSubFilterId={activeSubFilterId}
              setActiveSubFilterId={setActiveSubFilterId}
              filterMenuItemsId={filterMenuItemsId}
              isVisible={subCatLen > 1}
              activeFilterId={activeFilterId}
              subCategories={subCategories}
              setActiveSubFilter={setActiveSubFilter}
              subCategoriesId={subCategoriesId}
              setFilteredMenuItems={setFilteredMenuItems}
              lang={lang}
            />
          </FilterListContainer>
          <Element name="menu-items">
            <Container>
              <Grid container spacing={2} ref={gridRef}>
                {filteredMenuItems.map((menuItem, index) => (
                  <Grid item xs={12} md={6} key={index}>
   

                    <ClickableMenuItem item={menuItem} menu={menuUpd} />
  
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Element>
        </Element>
      </Section>
    </>
  );
}

export default React.memo(Menu);
